/* global __TARGET__ */

export const PUBLIC_KEY =
  __TARGET__ === 'prod' ? 'pk_live_4xKuDh4MDiZzEG1XUEnin1HK' : 'pk_test_0oFGUQxivGCgVX6MppDCFSNi';
